import React, {FC, Fragment, useState} from 'react';
import './style.scss';
import ItemTastesBrand from "../ItemTastesBrand";
import SearchPanel from "../SearchPanel";
import Header from "../../Header";
import goBack from "../../../assets/img/header/go__back.svg";
import {useHistory} from 'react-router-dom';

interface ITastesBrand {
    tastesBrand: any,
    handleMix: any,
    tastesID: Array<number>
}

const TastesBrand: FC<ITastesBrand> = ({
                                           tastesBrand,
                                           handleMix,
                                           tastesID
                                       }) => {
    const [value, setValue] = useState<string>('');
    const history = useHistory();
    return (
        <Fragment>
            <Header>
                <div className="standard__header">
                    <img
                        className="standard__header-img"
                        onClick={() => history.goBack()}
                        src={goBack}
                        alt="Go Back"
                    />
                    <div className="catalog-brands__text-cont">
                                <span className="header__standard-text">
                                     {tastesBrand[0].brandName}
                                 </span>
                    </div>
                </div>
            </Header>
            <div className="tastes-brand">
                <div className="tastes-brand__container">
                    <div className="tastes-brand__search-panel">
                        <SearchPanel
                            tobaccoCount={tastesID.length}
                            value={value}
                            setValue={setValue}
                        />
                    </div>
                    {
                        tastesBrand
                            .filter((item: any) => item.name.toLowerCase().includes(value.toLowerCase()))
                            .map((item: any) => {
                                return (
                                    <ItemTastesBrand
                                        tastesID={tastesID}
                                        handleMix={handleMix}
                                        brandName={item.brandName}
                                        id={item.id}
                                        name={item.name}
                                        key={item.id}
                                    />
                                )
                            })
                    }
                </div>
            </div>
        </Fragment>
    )
};

export default TastesBrand;
